import { Fragment, useCallback, useMemo, useState } from "react";
import BasicButton from "../../components/BasicButton";
import BasicInput from "../../components/BasicInput";
import { addAdminUser, AuthUserInfo, deleteUser, makeUserAdmin, useAdminList } from "../../misc/lib/user";
import DeleteRounded from "@material-ui/icons/DeleteRounded";
import WarningRounded from '@material-ui/icons/WarningRounded';
import './AdminPage.scss';
import { useHistory } from "react-router-dom";
import routes from "../../misc/routes";

const UsersAdminPanel = () => {
  return (
    <div className="adminpage-users-panel">
      <NewAdmin />
      <ExistingAdminList />
    </div>
  );
};

export default UsersAdminPanel;

const NewAdmin = () => {
  const [ email, setEmail ] = useState('');
  const [ name, setName ] = useState('');
  const [ pass1, setPass1 ] = useState('');
  const [ pass2, setPass2 ] = useState('');
  const [ accountCreating, setAccountCreating ] = useState(false);
  const history = useHistory();

  const canCreateAccount = useMemo(() => {
    return !!email && !!name && !!pass1 && !!pass2 && pass1 === pass2;
  }, [ email, pass1, pass2, name ]);

  const doCreateAccount = useCallback(() => {
    if (!canCreateAccount) return;

    setAccountCreating(true);
    addAdminUser(email, pass1, name).then((uid) => {
      console.log(`Created user with UID: ${ uid }`);
      setName(''); setEmail(''); setPass1(''); setPass2('');
      history.push(routes.admin.path + '?tab=users');
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setAccountCreating(false);
    });
  }, [ email, pass1, name, canCreateAccount, history ]);

  return (
    <div className="new-admin-form">
      <h2>Új adminisztrátori fiók létrehozása</h2>
      <form>
        <BasicInput placeholder="Név" text={ name } onTextChanged={ setName } />
        <BasicInput placeholder="E-mail" text={ email } onTextChanged={ setEmail } />
        <BasicInput placeholder="Jelszó" text={ pass1 } onTextChanged={ setPass1 }
          password />
        <BasicInput placeholder="Jelszó mégegyszer" text={ pass2 } onTextChanged={ setPass2 }
          password />
        <BasicButton text="Létrehozás" type="primary" onClick={ doCreateAccount }
          working={ accountCreating } disabled={ !canCreateAccount } />
      </form>
    </div>
  );
};

const ExistingAdminList = () => {
  const admins = useAdminList();

  return (
    <div className="existing-admin-list">
      <h2>Adminisztrátorok</h2>
      <div>
        { admins.map((u, i) => (
          <ExistingAdminCard { ...u } key={ i } />
        )) }
      </div>
    </div>
  );
};

const ExistingAdminCard = (props: AuthUserInfo) => {
  const [ makingAdmin, setMakingAdmin ] = useState(false);
  const [ deletingUser, setDeletingUser ] = useState(false);
  const history = useHistory();

  const doMakeAdmin = useCallback(() => {
    setMakingAdmin(true);
    makeUserAdmin(props.uid).then(() => {
      history.push(routes.admin.path + '?tab=users');
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setMakingAdmin(false);
    });
  }, [ props.uid, history ]);

  const doDeleteUser = useCallback(() => {
    setDeletingUser(true);
    deleteUser(props.uid).then(() => {
      history.push(routes.admin.path + '?tab=users');
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setDeletingUser(false);
    });
  }, [ history, props.uid ]);

  return (
    <Fragment>
      <div className="existing-admin-card">
        <p><b>{ props.displayName }</b></p>
        <p>{ props.email }</p>
        <p>{ props.uid }</p>
        <button type="button" className="icon-action-button"
          onClick={ doDeleteUser } disabled={ deletingUser }>
          <DeleteRounded color="inherit" />
        </button>
      </div>
      { !props.admin ? (
        <div className="existing-admin-card-error">
          <WarningRounded color="inherit" />
          <p><b>
            Ez a fiók nem rendelkezik adminisztrátori jogokkal.
          </b></p>
          <BasicButton text="Jogok megadása" type="warning" onClick={ doMakeAdmin }
            working={ makingAdmin } />
        </div>
      ) : null }
    </Fragment>
  );
};
